import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionAnswerMutation, deleteQuestionAnswerMutationVariables } from '../generated/deleteQuestionAnswerMutation';
import { questionAnswerFieldsFragment } from '../models/QuestionAnswer';

/**
 * Get a callback to delete a QuestionAnswer in the store.
 */
export function useDeleteQuestionAnswerCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionAnswerMutation, deleteQuestionAnswerMutationVariables>(
        gql`
            mutation deleteQuestionAnswerMutation ($id: ID!) {
                deleteQuestionAnswer(id: $id) {
                    ...questionAnswerFields
                }
            }

            ${questionAnswerFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
